// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { ReactElement } from 'react';

import { Route } from 'react-router-dom';

import { Methods } from '../pages/I.LAB';

function MethodsRoutes(): ReactElement {
  return (
    <>
      <Route path="/ilab/methods" exact component={Methods.MethodsList} />
      <Route
        path="/ilab/methods/cadaster"
        exact
        component={Methods.MethodCadaster}
      />
      <Route
        path="/ilab/methods/details/:methodId"
        exact
        component={Methods.MethodDetails}
      />
      <Route
        path="/ilab/methods/edit/:methodId"
        exact
        component={Methods.EditMethod}
      />
    </>
  );
}

export default MethodsRoutes;
